export const BASE_CHART_HEIGHT = 25;
export const CHART_HEIGHT_ADJ_BUTTON = 5;
export const CHART_BAR_HEIGHT = 2.8;
